/* unplugin-vue-components disabled */import { render } from "./consultantPerformance.vue?vue&type=template&id=77dba8a2&scoped=true"
import script from "./consultantPerformance.vue?vue&type=script&lang=js"
export * from "./consultantPerformance.vue?vue&type=script&lang=js"

import "./consultantPerformance.vue?vue&type=style&index=0&id=77dba8a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77dba8a2"]])

export default __exports__